import { InputSwitch } from 'primereact/inputswitch';
import React, {useEffect, useRef} from 'react';
import { customerUpdate } from '../../../services/CustomerInfo/EditCustomer';

const EditCustomerNotification = ({
  activeNotification,
  setActiveNotification,
  editCustomerData,
}) => {

  const handleEditData = async NotificationValue => {
    // Update the specific field in editCustomerData
    let updatedData = {...editCustomerData};
    updatedData.brandCustomer.customerType = 'customerType';
    updatedData.brandCustomer.notify = NotificationValue;

    // Add more conditions for other fields
    try {
      const response = await customerUpdate(updatedData);
      if (!response.data.error) {
        const Res = response.data;
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div
      style={{
        flex: 1,
        alignItems: 'center',
        margin: 15,
      }}>
      <div
        style={{
          // flexDirection: 'row',
          // position: 'relative',
          height:  20,
          borderRadius: 30,
          elevation: 2,
          // backgroundColor: '#efebf0',
          // width: '49%',
        }}>
          <InputSwitch checked={activeNotification} onChange={() => (
            setActiveNotification(!activeNotification),
            handleEditData(!activeNotification)
          )} />
      </div>
    </div>
  );
};
export default EditCustomerNotification;
